import { useState, useEffect } from 'react'
import axios from "axios";
import { Link } from "react-router-dom";
 
const MovieList = () => {
    const [movie, setMovie] = useState([]);
 
    useEffect(() => {
        getMovies();
    }, []);
 
    const getMovies = async () => {
        //const response = await axios.get('http://localhost:5000/products');
        const response = await axios.get('http://10.100.5.11:3307/movies');
        setMovie(response.data);
    }
 
    const deleteMovie = async (id) => {
        //await axios.delete(`http://localhost:5000/products/${id}`);
        await axios.delete(`http://10.100.5.11:3307/movies/${id}`);
        getMovies();
    }
 
    return (
        <div>
            <Link to="/add" className="button is-primary mt-2">Add New</Link>
            <table className="table is-striped is-fullwidth">
                <thead>
                    <tr>
                        <th>No</th>
                        <th>Title</th>
                        <th>Price</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    { movie.map((movie, index) => (
                        <tr key={ movie.Entry_Number }>
                            <td>{ index + 1 }</td>
                            <td>{ movie.Title }</td>
                            <td>{ movie.Price }</td>
                            <td>
                                <Link to={`/edit/${movie.Entry_Number}`} className="button is-small is-info">Edit</Link>
                                <button onClick={ () => deleteMovie(movie.Entry_Number) } className="button is-small is-danger">Delete</button>
                            </td>
                        </tr>
                    )) }
                     
                </tbody>
            </table>
        </div>
    )
}
 
export default MovieList